// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__HE5vC","wide":"styles_wide__1RriS"};